import { render, staticRenderFns } from "./DetailedApprovalReport.vue?vue&type=template&id=d6a5eb64"
import script from "./DetailedApprovalReport.vue?vue&type=script&lang=js"
export * from "./DetailedApprovalReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports